import axios, { AxiosError } from 'axios';
import { SELF_SERVICE_API_URL } from 'config';
import type { SelfServiceAPI } from 'types';
import handleServiceError from '../utils/handleServiceError';

export interface Params {
  limit: number;
  offset: number;
  filter: string;
}

interface Options {
  skipUnauthenticatedRedirection?: boolean;
  retry?: boolean;
  signal?: AbortSignal;
}

const getBookings = async (params: Params, options: Options = {}): Promise<SelfServiceAPI.GetBookings.Response> => {
  try {
    const { data } = await axios.get<SelfServiceAPI.GetBookings.Response>(`${SELF_SERVICE_API_URL}/bookings`, {
      params,
      withCredentials: true,
      signal: options.signal,
    });

    return data;
  } catch (error) {
    if (options.retry !== false) {
      const status = error instanceof AxiosError && error.response?.status;

      if (status === 500) {
        return await getBookings(params, { ...options, retry: false });
      }
    }

    handleServiceError(error, {
      operationName: `GET /bookings`,
      skipUnauthenticatedRedirection: options.skipUnauthenticatedRedirection,
    });

    return new Promise(() => {});
  }
};

export default getBookings;
